import React, { useEffect, useState } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm"; // Importar el modal de confirmación
import ModalAgregarPago from './ModalAgregarPago';


const Pagos = ({ restauranteId, comandaId }) => {
    const [pagos, setPagos] = useState([]);
    const [busqueda, setBusqueda] = useState(""); // Controla la barra de búsqueda
    const [pagoSeleccionado, setPagoSeleccionado] = useState(null); // Para almacenar el pago seleccionado
    const [editandoPago, setEditandoPago] = useState(null); // Controla la edición de pagos
    const [showConfirmModal, setShowConfirmModal] = useState(false); // Para el modal de confirmación
    const [nuevoPago, setNuevoPago] = useState({ descripcion: "", monto: "", fecha: "" }); // Para agregar nuevo pago
    const [mostrarFormulario, setMostrarFormulario] = useState(false); // Controla la visibilidad del formulario para agregar pagos
    const [nombreRestaurante, setNombreRestaurante] = useState(""); // Estado para almacenar el nombre del restaurante

    // Función para obtener los datos del restaurante usando el restauranteId
    const obtenerRestaurante = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "restaurantes"
            });

            const restaurante = response.data.data[0].find(item => item.id === restauranteId);
            if (restaurante) {
                setNombreRestaurante(restaurante.nombre); // Almacenar el nombre del restaurante
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Obtener pagos completos
    const obtenerPagos = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "pagos"
            });
            
            if (response.data && response.data.data && Array.isArray(response.data.data[0])) {
                setPagos(response.data.data[0]); // Guardar los pagos
            } else {
                console.error("La estructura de la respuesta no es la esperada.");
            }
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        obtenerRestaurante(); // Llamamos la función para obtener los detalles del restaurante
        obtenerPagos();  // Llamamos la función para obtener los pagos
    }, [restauranteId]);

    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };


    // Filtrar pagos por comanda_id y búsqueda
const pagosFiltrados = pagos.filter((pago) =>
    pago.comanda_id === comandaId &&  // Filtrar por comanda_id
    (
        (pago.metodo_pago && pago.metodo_pago.toLowerCase().includes(busqueda)) ||  // Filtrar por método de pago
        (pago.monto && pago.monto.toString().includes(busqueda)) ||  // Filtrar por monto
        (pago.fecha_pago && pago.fecha_pago.includes(busqueda))  // Filtrar por fecha de pago
    )
);


    // Función para manejar la edición de un pago
    const editarPago = (pago) => {
        setEditandoPago(pago);
    };

    // Función para guardar los cambios del pago editado
    const guardarPagoEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "pagos",
                id: editandoPago.id,
                comanda_id: editandoPago.comanda_id, 
                metodo_pago: editandoPago.metodo_pago, 
                monto: editandoPago.monto,
                fecha_pago: editandoPago.fecha_pago 
            });
            setEditandoPago(null);
            obtenerPagos(); 
        } catch (error) {
            console.log(error);
        }
    };
    

    
    const confirmarEliminarPago = (pago) => {
        setPagoSeleccionado(pago);
        setShowConfirmModal(true); 
    };

    const eliminarPago = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar", 
                modulo: "pagos",
                id: pagoSeleccionado.id
            });
            setShowConfirmModal(false); 
            obtenerPagos(); 
        } catch (error) {
            console.log(error);
        }
    };


    return (
        <div>
            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Pagos del Restaurante: {nombreRestaurante}</h3>

                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar pago..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                />

                {/* Botón para mostrar el formulario de agregar pago */}
                <button
                    onClick={() => setMostrarFormulario(true)}
                    className="bg-blue-500 text-white rounded px-4 py-2 mt-4 ml-6 hover:bg-blue-400"
                >
                    Agregar Nuevo Pago
                </button>

                <ul>
                    {pagosFiltrados.map((pago) => (
                        <li key={pago.id} className="border p-2 mb-2 mt-4">
                            {editandoPago && editandoPago.id === pago.id ? (
                                <div className="flex flex-col">
                                    <h3 className=" font-semibold mt-2">Método de Pago:</h3>
                                    <input
                                        type="text"
                                        value={editandoPago.metodo_pago}
                                        onChange={(e) =>
                                            setEditandoPago({ ...editandoPago, metodo_pago: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={20}
                                    />
                                    <h3 className=" font-semibold mt-2">Monto:</h3>
                                    <input
                                        type="number"
                                        value={editandoPago.monto}
                                        onChange={(e) =>
                                            setEditandoPago({ ...editandoPago, monto: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={10}
                                    />
                                    <h3 className=" font-semibold mt-2">Fecha de Pago:</h3>
                                    <input
                                        type="date"
                                        value={editandoPago.fecha_pago}
                                        onChange={(e) =>
                                            setEditandoPago({ ...editandoPago, fecha_pago: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                    />
                                    <div className="flex mt-4 mb-2">
                                        <button
                                            onClick={guardarPagoEditado}
                                            className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                        >
                                            Guardar
                                        </button>
                                        <button
                                            onClick={() => setEditandoPago(null)}
                                            className="bg-gray-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <span><strong>Método de Pago:</strong> {pago.metodo_pago}</span><br />
                                    <span><strong>Monto:</strong> ${pago.monto}</span><br />
                                    <span><strong>Fecha de Pago:</strong> {pago.fecha_pago || "No disponible"}</span><br />
                                    <button
                                        onClick={() => editarPago(pago)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarPago(pago)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>

            </div>

            {/* Modal de confirmación */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este pago?"
                onConfirm={eliminarPago}
                onCancel={() => setShowConfirmModal(false)}
            />

            <ModalAgregarPago
                show={mostrarFormulario}
                onClose={() => setMostrarFormulario(false)}
                comandaId={comandaId}
                onPagoAgregado={obtenerPagos} // Actualiza los pagos después de agregar uno nuevo
            />
        </div>
    );
};

export default Pagos;
